// Bulk action picker — drives a [data-bulk-form] whose
// [data-bulk-action] select names what to do with the selection.
//
// The pick lands on the form as data-picked, which the markup's
// group-data variants read to show that action's field. Every other
// [data-bulk-field] fieldset is disabled, which keeps its stale value
// out of the submit and out of the tab order. [data-bulk-apply] turns
// on once the picked action has what it needs, takes the option's verb
// as its label, and carries the option's data-confirm-* so only the
// actions that need a confirm ask for one. A {reason} in the confirm
// body becomes the reason picked. [data-bulk-hint] tells a screen
// reader which field appeared.

import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();
const CONFIRM_KEYS = ["confirmBody", "confirmCta", "confirmTone"];

export function initBulkActions(root = document) {
  root.querySelectorAll("[data-bulk-form]").forEach((form) => {
    if (!firstBind(form)) return;

    const picker = form.querySelector("[data-bulk-action]");
    const apply = form.querySelector("[data-bulk-apply]");
    const hint = form.querySelector("[data-bulk-hint]");
    const fields = Array.from(form.querySelectorAll("[data-bulk-field]"));
    if (!picker || !apply) return;

    const fieldFor = (value) =>
      fields.find((f) => f.dataset.bulkField.split(" ").includes(value));

    const update = () => {
      const option = picker.selectedOptions[0];
      const value = picker.value;
      const field = fieldFor(value);
      const input = field?.querySelector("input, select");

      form.dataset.picked = value;
      fields.forEach((f) => {
        f.disabled = f !== field;
      });
      apply.disabled = !value || Boolean(input && !input.value.trim());
      apply.textContent = option?.dataset.applyLabel || "Apply";

      delete apply.dataset.confirm;
      delete apply.dataset.bulkConfirmTitle;
      delete apply.dataset.confirmTitle;
      CONFIRM_KEYS.forEach((key) => delete apply.dataset[key]);
      if (option?.dataset.confirmTitle) {
        const reason =
          input?.tagName === "SELECT"
            ? input.selectedOptions[0]?.textContent.trim()
            : "";
        apply.dataset.confirm = "";
        apply.dataset.bulkConfirmTitle = option.dataset.confirmTitle;
        CONFIRM_KEYS.forEach((key) => {
          if (option.dataset[key]) apply.dataset[key] = option.dataset[key];
        });
        if (apply.dataset.confirmBody) {
          apply.dataset.confirmBody = apply.dataset.confirmBody.replace(
            "{reason}",
            reason,
          );
        }
      }

      // bulk_select.js fills the selection's size into the title.
      form.dispatchEvent(new CustomEvent("bulk:sync", { bubbles: true }));
    };

    picker.addEventListener("change", () => {
      update();
      if (hint)
        hint.textContent = picker.selectedOptions[0]?.dataset.hint || "";
    });
    form.addEventListener("input", (event) => {
      if (event.target !== picker) update();
    });
    form.addEventListener("change", (event) => {
      if (event.target !== picker) update();
    });

    update();
  });
}
